import React from 'react';
import { trustBadges } from '../data/mock';
import { CountUp } from './CountUp';

const BadgeText = ({ text, count }) => {
  const [before, after] = text.split('{count}');
  return <>{before}<span className="text-red-600"><CountUp end={count} /></span>{after}</>;
};

export const TrustBar = () => {
  return (
    <section className="relative bg-white" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 -mt-10 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 bg-white border border-neutral-200 shadow-xl shadow-neutral-900/5 rounded-sm p-4 md:p-6">
          {trustBadges.map((badge) => (
            <div
              key={badge.id}
              className="flex items-center gap-3 md:gap-4 p-2 group"
              data-testid={`trust-badge-${badge.id}`}
            >
              <img
                src={badge.image}
                alt=""
                className="w-14 h-14 md:w-16 md:h-16 object-contain shrink-0 group-hover:-translate-y-1 transition-transform duration-300"
              />
              <div>
                <div className="font-display uppercase font-bold text-neutral-950 text-base md:text-lg leading-tight">
                  {badge.count ? <BadgeText text={badge.text} count={badge.count} /> : badge.text}
                </div>
                <div className="text-neutral-500 text-xs md:text-sm">{badge.subtext}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
